'use client';

import { useVirtualizer, VirtualItem } from '@tanstack/react-virtual';
import { FC, useRef } from 'react';

type Props = {
  count: number;
  estimatedSize: number;
  overscan: number;
  as: React.ComponentType<{ item: VirtualItem }>;
};

const VerticalVirtualizer: FC<Props> = ({ count, estimatedSize, overscan, as: Component }) => {
  const parentRef = useRef(null);
  // eslint-disable-next-line react-hooks/incompatible-library
  const virtualizer = useVirtualizer({
    count,
    overscan,
    getScrollElement: () => parentRef.current,
    estimateSize: () => estimatedSize,
  });

  const virtualItems = virtualizer.getVirtualItems();

  return (
    <div ref={parentRef} className="h-full overflow-y-auto">
      <div className="relative w-full" style={{ height: `${virtualizer.getTotalSize()}px` }}>
        {virtualItems.map((item) => (
          <Component key={item.key} item={item} />
        ))}
      </div>
    </div>
  );
};

export default VerticalVirtualizer;
